'use strict';

var _ = require('lodash');
var CompetitorPanelChartService = function CompetitorPanelChartService() {
  function effectiveFaresAvailable(recommendationEntry) {
    return !_.find(recommendationEntry.groupedRows, function (recommendation) {
      return _.isNil(recommendation.effectiveTotalFare);
    });
  }
  function recommendationsAvailable(recommendationEntry) {
    return !_.find(recommendationEntry.groupedRows, function (recommendation) {
      return _.isNil(recommendation.recommendedFareTotal);
    });
  }
  function getAllCompetitorTotalFares(selectedFareLadder) {
    if (!(selectedFareLadder && selectedFareLadder.category)) {
      return [];
    }
    return selectedFareLadder.category === 'STRUCTURAL' ? getAllStructuralCompetitorTotalFares(selectedFareLadder) : getAllTacticalCompetitorTotalFares(selectedFareLadder);
  }
  function getAllStructuralCompetitorTotalFares(selectedFareLadder) {
    var competitorLadder1 = selectedFareLadder.competitorData1.competitorFareLadder;
    var competitorLadder2 = selectedFareLadder.competitorData2.competitorFareLadder;
    var competitorLadder3 = selectedFareLadder.competitorData3.competitorFareLadder;
    return _.union(getCompetitorTotalFares(competitorLadder1), getCompetitorTotalFares(competitorLadder2), getCompetitorTotalFares(competitorLadder3));
  }
  function getAllTacticalCompetitorTotalFares(selectedFareLadder) {
    return _.reduce(selectedFareLadder.competitorsData, function (result, competitorData) {
      return _.union(result, [competitorData.totalFare]);
    }, []);
  }
  function getAllHostFaresInLadder(selectedFareLadder) {
    var recommendationsPresent = recommendationsAvailable(selectedFareLadder);
    var effectiveFaresPresent = effectiveFaresAvailable(selectedFareLadder);
    return _.flatMap(_.chain(selectedFareLadder.groupedRows).filter(isNonLinkedFbc).filter(isNonDualRbdFare).map(function (row) {
      return [recommendationsPresent ? row.recommendedFareTotal : null, effectiveFaresPresent ? row.effectiveTotalFare : null, row.currentFareTotal];
    }).flatten().value());
  }
  function getAllHostFaresInUpdatedLadder(updatedHostLadder) {
    var recommendationsPresent = !_.find(updatedHostLadder, function (recommendation) {
      return _.isNil(recommendation.recommendedFareTotal);
    });
    var effectiveFaresPresent = !_.find(updatedHostLadder, function (recommendation) {
      return _.isNil(recommendation.effectiveTotalFare);
    });
    return _.flatMap(_.chain(updatedHostLadder).filter(isNonLinkedFbc).filter(isNonDualRbdFare).map(function (row) {
      return [recommendationsPresent ? row.recommendedFareTotal : null, effectiveFaresPresent ? row.effectiveTotalFare : null, row.currentFareTotal];
    }).flatten().value());
  }
  function getCompetitorTotalFares(competitorLadder) {
    return _.flatMap(_.chain(competitorLadder).filter(isNonLinkedFbc).filter(isNonDualRbdFare).map(function (row) {
      return row.totalFare;
    }).flatten().value());
  }
  function getFareChartScaleSettings(selectedFareLadder, updatedHostLadder) {
    var groupedFares = [];
    if (_.isNil(updatedHostLadder)) {
      groupedFares = _.union(getAllCompetitorTotalFares(selectedFareLadder), getAllHostFaresInLadder(selectedFareLadder));
    } else {
      groupedFares = _.union(getAllCompetitorTotalFares(selectedFareLadder), getAllHostFaresInUpdatedLadder(updatedHostLadder));
    }
    return {
      fareRange: [Math.round(_.min(groupedFares)), Math.round(_.max(groupedFares))]
    };
  }
  function isNonLinkedFbc(row) {
    return _.isNil(row.isLinkedFbc) || row.isLinkedFbc === false;
  }
  function isNonDualRbdFare(row) {
    return _.isNil(row.isDualRbdFare) || row.isDualRbdFare === false;
  }
  return {
    getFareChartScaleSettings: getFareChartScaleSettings
  };
};
CompetitorPanelChartService.$inject = [];
module.exports = CompetitorPanelChartService;